import alignElement from './align/alignElement';
import alignPoint from './align/alignPoint';
export { alignElement, alignPoint };
export default alignElement;